import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LocalizationService {
  backendUrl: string;
  constructor(private http: HttpClient) {
    this.backendUrl = environment.backendURLV2;
  }
  getLocalization() {
    return this.http.get(this.backendUrl + '/location')
  }
}
